import { GetDeviceDetailsResponse, PartnerLogoDetails, UserResponse } from '../models/commonTypeScript';
import fetch from './fetch';
import getFetchHeaders from './getFetchHeaders';

export interface UpdateUserSettingsRequest {
    units: {
        radonUnit: string;
        tempUnit: string;
        pressureUnit: string;
        vocUnit: string;
    };
    dateFormat?: string;
    language?: string;
}

export default async (settings: UpdateUserSettingsRequest): Promise<void> => {
    return fetch<void>(
        '/user/preferences',
        {
            method: 'PATCH',
            headers: await getFetchHeaders(),
            body: JSON.stringify(settings),
        },
        true
    );
};

export const getUserInfo = async (): Promise<UserResponse> =>
    fetch<UserResponse>(
        '/user',
        {
            method: 'GET',
            headers: await getFetchHeaders(),
        },
        true
    );

export const getDeviceDetails = async (): Promise<GetDeviceDetailsResponse> =>
    fetch<GetDeviceDetailsResponse>(
        '/device-specs',
        {
            method: 'GET',
            headers: await getFetchHeaders(),
        },
        true
    );

export const fetchPartnerLogo = async (): Promise<PartnerLogoDetails> => {
    return fetch(
        '/organization/partner-logo',
        {
            method: 'GET',
            headers: await getFetchHeaders(),
        },
        true
    );
};
